export default __webpack_public_path__ + "static/media/polymerisationsstress.ffb7fb61.svg";